import { TableCellData_VerticalAlignment } from "./plugin_table_cell.enums";
function tableCellData_VerticalAlignmentFromJSON(object) {
  switch (object) {
    case 0:
    case "TOP":
      return TableCellData_VerticalAlignment.TOP;
    case 1:
    case "MIDDLE":
      return TableCellData_VerticalAlignment.MIDDLE;
    case 2:
    case "BOTTOM":
      return TableCellData_VerticalAlignment.BOTTOM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TableCellData_VerticalAlignment.UNRECOGNIZED;
  }
}
function tableCellData_VerticalAlignmentToJSON(object) {
  switch (object) {
    case TableCellData_VerticalAlignment.TOP:
      return "TOP";
    case TableCellData_VerticalAlignment.MIDDLE:
      return "MIDDLE";
    case TableCellData_VerticalAlignment.BOTTOM:
      return "BOTTOM";
    default:
      return "UNKNOWN";
  }
}
const baseTableCellData = {};
const TableCellData = {
  fromJSON(object) {
    const message = { ...baseTableCellData };
    message.cellStyle = object.cellStyle !== void 0 && object.cellStyle !== null ? TableCellData_CellStyle.fromJSON(object.cellStyle) : void 0;
    message.borderColors = object.borderColors !== void 0 && object.borderColors !== null ? TableCellData_BorderColors.fromJSON(object.borderColors) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.cellStyle !== void 0 && (obj.cellStyle = message.cellStyle ? TableCellData_CellStyle.toJSON(message.cellStyle) : void 0);
    message.borderColors !== void 0 && (obj.borderColors = message.borderColors ? TableCellData_BorderColors.toJSON(message.borderColors) : void 0);
    return obj;
  }
};
const baseTableCellData_CellStyle = {
  verticalAlignment: TableCellData_VerticalAlignment.TOP
};
const TableCellData_CellStyle = {
  fromJSON(object) {
    const message = { ...baseTableCellData_CellStyle };
    message.verticalAlignment = object.verticalAlignment !== void 0 && object.verticalAlignment !== null ? tableCellData_VerticalAlignmentFromJSON(object.verticalAlignment) : TableCellData_VerticalAlignment.TOP;
    message.backgroundColor = object.backgroundColor !== void 0 && object.backgroundColor !== null ? String(object.backgroundColor) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.verticalAlignment !== void 0 && (obj.verticalAlignment = tableCellData_VerticalAlignmentToJSON(message.verticalAlignment));
    message.backgroundColor !== void 0 && (obj.backgroundColor = message.backgroundColor);
    return obj;
  }
};
const baseTableCellData_BorderColors = {};
const TableCellData_BorderColors = {
  fromJSON(object) {
    const message = { ...baseTableCellData_BorderColors };
    message.left = object.left !== void 0 && object.left !== null ? String(object.left) : void 0;
    message.right = object.right !== void 0 && object.right !== null ? String(object.right) : void 0;
    message.top = object.top !== void 0 && object.top !== null ? String(object.top) : void 0;
    message.bottom = object.bottom !== void 0 && object.bottom !== null ? String(object.bottom) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.left !== void 0 && (obj.left = message.left);
    message.right !== void 0 && (obj.right = message.right);
    message.top !== void 0 && (obj.top = message.top);
    message.bottom !== void 0 && (obj.bottom = message.bottom);
    return obj;
  }
};
export {
  TableCellData,
  TableCellData_BorderColors,
  TableCellData_CellStyle,
  tableCellData_VerticalAlignmentFromJSON,
  tableCellData_VerticalAlignmentToJSON
};
//# sourceMappingURL=plugin_table_cell.js.map
